import Link from 'next/link';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { dateToScheduleFormat } from '../helpers';
import ScheduleTooltip from '../ScheduleTooltip';
import * as ST from './styled';

class ChannelCommon extends Component {
    static defaultProps = {
        broadcasts: [],
    };

    state = {
        broadcasts: this.props.broadcasts,
        tooltipData: {},
    }

    constructor(props) {
        super(props);

        this.broadcastNode = React.createRef();
        this.broadcastTimer = null;
    }

    componentDidMount() {
        this.updateProgress();
        this.broadcastTimer = setInterval(this.updateProgress, 10000);
    }

    componentDidUpdate({ broadcasts }) {
        if (JSON.stringify(this.props.broadcasts) !== JSON.stringify(broadcasts)) {
            clearInterval(this.broadcastTimer);
            this.updateProgress();
            this.broadcastTimer = setInterval(this.updateProgress, 10000);
        }
    }

    componentWillUnmount() {
        clearInterval(this.broadcastTimer);
    }

    updateScroll() {
        const activeBroadcast = this.broadcastNode.current.querySelector('.broadcast_active');
        if (activeBroadcast === null) {
            return;
        }
        this.broadcastNode.current.scrollTop = activeBroadcast.offsetTop;
    }

    updateProgress = () => {
        const getCurrentCityDateByOffset = (offset) => {
            const nowDate = new Date();
            return (
                new Date(nowDate.setTime(nowDate.getTime() + nowDate.getTimezoneOffset() * 60000 + offset * 1000))
            );
        };
        const currentCityDate = getCurrentCityDateByOffset(this.props.currentCityTimeZoneOffset);
        const newBroadcasts = [...this.props.broadcasts];
        const commonStatus = newBroadcasts.every(broadcast => {
            broadcast.status = false;

            const broadcastStart = typeof broadcast.start === 'string' ? new Date(broadcast.start) : broadcast.start;
            const broadcastFinish = typeof broadcast.start === 'string' ? new Date(broadcast.finish) : broadcast.finish;

            if (currentCityDate >= broadcastStart.getTime() && currentCityDate < broadcastFinish.getTime()) {
                broadcast.status = true;
                broadcast.progress = ((currentCityDate - broadcastStart.getTime()) / (broadcast.duration * 1000) * 100)
                    .toFixed(2);
                return false;
            }

            return true;
        });

        if (commonStatus === true) {
            this.setState({ broadcasts: this.props.broadcasts });
            clearInterval(this.broadcastTimer);
        } else {
            this.setState({ broadcasts: newBroadcasts }, this.updateScroll);
        }
    }

    onBroadcastClick = (event, broadcast) => {
        const content = {
            title: broadcast.title,
            desc: broadcast.desc,
            icon: broadcast.icon,
        };

        const coordinates = {
            x: event.clientX,
            y: event.clientY,
        };

        this.tooltipOpen(content, coordinates);
    }

    tooltipOpen = (content, coordinates) => {
        this.setState({
            tooltipData: {
                isShow: true,
                content,
                container: this.props.scheduleContainer.current,
                coordinates,
            },
        });
    }

    tooltipClose = () => {
        this.setState({
            tooltipData: {
                isShow: false,
                content: null,
            },
        });
    }

    render() {
        const broadcastList = this.state.broadcasts.map((broadcast, index) => {
            let progress = null;

            if (broadcast.status === true) {
                progress = (
                    <ST.BroadcastProgress>
                        <ST.BroadcastProgressBar style={{ width: `${broadcast.progress}%` }}></ST.BroadcastProgressBar>
                    </ST.BroadcastProgress>
                );
            }

            const broadcastStart = typeof broadcast.start === 'string' ? new Date(broadcast.start) : broadcast.start;

            return (
                <ST.Broadcast
                    broadcastStatus={broadcast.status}
                    key={broadcast.start + index}
                    className={broadcast.status === true ? 'broadcast_active' : ''}
                    onClick={(event) => this.onBroadcastClick(event, broadcast) }
                    tabIndex='0'
                >
                    <ST.BroadcastTime>{dateToScheduleFormat(broadcastStart)}</ST.BroadcastTime>
                    <ST.BroadcastTitle>
                        {broadcast.title}
                        {progress}
                    </ST.BroadcastTitle>
                </ST.Broadcast>
            );
        });

        let tooltip = null;
        if (this.state.tooltipData.isShow) {
            tooltip = (<ScheduleTooltip tooltipClose={this.tooltipClose} {...this.state.tooltipData} />);
        }

        return (
            <ST.CommonChannel>
                <ST.ChannelDescription>
                    <ST.ChannelDescriptionPicture>
                        <ST.ChannelDescriptionImage src={this.props.logo} alt={this.props.title} />
                    </ST.ChannelDescriptionPicture>
                    <ST.ChannelDescriptionContent>
                        <Link
                            href={`/domru-tv/channel/_detail?id=${this.props.alias}`}
                            as={`/domru-tv/channel/${this.props.alias}`}
                            scroll={false}
                            passHref
                        >
                            <ST.ChannelDescriptionLink>
                                <ST.ChannelDescriptionTitle>{this.props.title}</ST.ChannelDescriptionTitle>
                            </ST.ChannelDescriptionLink>
                        </Link>
                        <ST.ChannelDescriptionNumber>Кнопка №{this.props.button}</ST.ChannelDescriptionNumber>
                    </ST.ChannelDescriptionContent>
                </ST.ChannelDescription>

                <ST.BroadcastContainer ref={this.broadcastNode}>
                    {broadcastList}
                </ST.BroadcastContainer>
                {tooltip}
            </ST.CommonChannel>
        );
    }
}

const mapStateToProps = (state) => ({
    currentCityTimeZoneOffset: state.city.currentCity.timeZone,
});

export default connect(mapStateToProps)(ChannelCommon);
